// extracted by mini-css-extract-plugin
module.exports = {"votes":"PollVotes_votes__3rtSP","label":"PollVotes_label__2nuu5","answer":"PollVotes_answer__slUMF","danger":"PollVotes_danger__19s7v","load":"PollVotes_load__1KsBz"};